// extracted by mini-css-extract-plugin
export var chip = "_51-0";
export var filterDropdown = "_51-5";
export var filterItem = "_51-6";
export var icon = "_51-1";
export var removeButton = "_51-3";
export var removeIcon = "_51-4";
export var separator = "_51-2";